import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/MoonMark";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function Legal() {
  return (
    <div className="min-h-screen bg-ink text-cream grain">
      <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-line glass px-5 lg:px-10">
        <Link to="/"><Wordmark /></Link>
        <Link to="/"><Button variant="outline" className="gap-2 border-line bg-surface hover:bg-raised"><ArrowLeft size={15} /> Home</Button></Link>
      </header>
      <div className="mx-auto max-w-2xl px-5 py-14 lg:px-10 text-sm leading-relaxed text-dust">
        <h1 className="text-3xl font-bold tracking-tight text-cream sm:text-4xl">Legal & disclaimers</h1>
        <div className="mt-8 space-y-5">
          <p>Wen Moon is a software tool for launching and marketing tokens on third-party launchpads. It is not a broker, exchange, investment adviser, or launchpad, and it does not custody your keys.</p>
          <p>Nothing in this product is financial advice. Wen Moon makes no promise of volume, trending, listing, price, or returns. Crypto assets are volatile and you can lose everything.</p>
          <p>You are solely responsible for the legality of your token, your marketing, and your compliance with the terms of each launchpad and social platform you use. The wizard blocks scam-pattern and guarantee copy, but you remain responsible.</p>
          <p>You sign every launch transaction with your own wallet. Payments are upfront and non-refundable once agents begin work. Burns execute on public ledgers and are visible on Moon Burns.</p>
          <p>Creator fees are custodied in the Wen Moon Fee Router. Social-handle destinations are claim keys, not on-chain payees: each fee lot is claimable for 7 days, and any lot left unclaimed after that window is used to buy and burn $MOON. Wallet destinations pay through on sweep. All demo transactions are labelled SIMULATED.</p>
          <p>By connecting a wallet you agree you are of legal age and that using Wen Moon is permitted in your jurisdiction.</p>
        </div>
      </div>
    </div>
  );
}
